import { Helpers } from '@bode-canada/core';
import {
  MarketDataFilterFormControlName,
} from '@/components/features/market-data/components/filters/MarketDataFiltersFormControls';
import { QueryParams } from '@/constants/QueryParams';

export default class MarketDataFilterFormQueryMapper {
  static mapFromQueries(queries) {
    return Helpers.ObjectHelper.removeEmptyProperties({
      [MarketDataFilterFormControlName.Province]: queries[QueryParams.Province],
      [MarketDataFilterFormControlName.City]: queries[QueryParams.City],
      [MarketDataFilterFormControlName.TransactionDate]: queries[QueryParams.TransactionDate],
      [MarketDataFilterFormControlName.Community]: this.#isString(queries[QueryParams.Community]) ? queries[QueryParams.Community].split(',') : undefined,
      [MarketDataFilterFormControlName.BuildingClass]: this.#isString(queries[QueryParams.BuildingClass]) ? queries[QueryParams.BuildingClass].split(',') : undefined,
      [MarketDataFilterFormControlName.Beds]: this.#isString(queries[QueryParams.Beds]) ? queries[QueryParams.Beds].split(',').map(Number) : undefined,
      [MarketDataFilterFormControlName.Baths]: this.#isString(queries[QueryParams.Baths]) ? queries[QueryParams.Baths].split(',').map(Number) : undefined,
      [MarketDataFilterFormControlName.MinPrice]: Number(queries[QueryParams.MinPrice]) || '',
      [MarketDataFilterFormControlName.MaxPrice]: Number(queries[QueryParams.MaxPrice]) || '',
      [MarketDataFilterFormControlName.MinYearBuilt]: Number(queries[QueryParams.MinYearBuilt]) || '',
      [MarketDataFilterFormControlName.MaxYearBuilt]: Number(queries[QueryParams.MaxYearBuilt]) || '',
    });
  }

  static mapToQueries(formData) {
    return Helpers.ObjectHelper.removeEmptyProperties({
      [QueryParams.Province]: formData[MarketDataFilterFormControlName.Province],
      [QueryParams.City]: formData[MarketDataFilterFormControlName.City],
      [QueryParams.TransactionDate]: formData[MarketDataFilterFormControlName.TransactionDate],
      [QueryParams.Community]: formData[MarketDataFilterFormControlName.Community].join(','),
      [QueryParams.BuildingClass]: formData[MarketDataFilterFormControlName.BuildingClass].join(','),
      [QueryParams.Beds]: formData[MarketDataFilterFormControlName.Beds].join(','),
      [QueryParams.Baths]: formData[MarketDataFilterFormControlName.Baths].join(','),
      [QueryParams.MinPrice]: formData[MarketDataFilterFormControlName.MinPrice],
      [QueryParams.MaxPrice]: formData[MarketDataFilterFormControlName.MaxPrice],
      [QueryParams.MinYearBuilt]: formData[MarketDataFilterFormControlName.MinYearBuilt],
      [QueryParams.MaxYearBuilt]: formData[MarketDataFilterFormControlName.MaxYearBuilt],
    });
  }

  static #isString(value) {
    return typeof value === 'string';
  }
}
